import { ProgramService } from '@modules/program/program-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    loading: false,
  },

  getters: {
    loading: (state) => !!state.loading,
  },

  mutations: {
    DESTROY_ALL_STARTED(state) {
      state.loading = true;
    },

    DESTROY_ALL_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ALL_ERROR(state) {
      state.loading = false;
    },

    DESTROY_STARTED(state) {
      state.loading = true;
    },

    DESTROY_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ERROR(state) {
      state.loading = false;
    },
  },

  actions: {
    async doDestroy({ commit, dispatch, rootGetters }, {id , manage}) {
      try {
        commit('DESTROY_STARTED');

        const manageInput = new ManageModel(manage).getManageModel()
        await ProgramService.destroyAll([id], manageInput);

        commit('DESTROY_SUCCESS');

        Message.success(i18n('entities.program.destroy.success'));

        dispatch(
          `${'program/list'}/doFetch`,
         {filter: rootGetters[`${'program/list'}/filter`]},
          {
            root: true,
          },
        );

      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ERROR');
      }
    },

    async doDestroyAll(
      { commit, dispatch, rootGetters },
      {ids, manage},
    ) {
      try {
        commit('DESTROY_ALL_STARTED');

        const manageInput = new ManageModel(manage).getManageModel()
        await ProgramService.destroyAll(ids, manageInput);

        commit('DESTROY_ALL_SUCCESS');

        dispatch(`${'program/list'}/doUnselectAll`, null, {
          root: true,
        });

        Message.success(
          i18n('entities.program.destroyAll.success'),
        );

        routerAsync().push( { name: 'programList', params: {manage}});

        dispatch(
          `${'program/list'}/doFetch`,
          rootGetters[`${'program/list'}/filter`],
          {
            root: true,
          },
        );
      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ALL_ERROR');
      }
    },
  },
};
